import { render } from "./newClient.vue?vue&type=template&id=6752d4f2&scoped=true"
import script from "./newClient.vue?vue&type=script&lang=js"
export * from "./newClient.vue?vue&type=script&lang=js"

import "./newClient.vue?vue&type=style&index=0&id=6752d4f2&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6752d4f2"]])

export default __exports__